// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2oheC","signatureButtonsRight":"ModalSign_signatureButtonsRight__UeN59"};